<template>
  <div class="contact-card">
    <div class="contact-card__line">
      <span>{{ name }}:</span>
      <span class="contact-card__name">{{ userName }}</span>
    </div>
    <div class="contact-card__line contact-card__line-email" v-if="email">
      <div class="contact-card__line-email-wrapper">
        <img class="contact-card__email-icon" src="@/assets/images/icons/envelope.svg" />
        <a class="contact-card__email contact-value" :href="`mailto:${email}`">
          <span class="contact-value">{{ email }}</span>
        </a>
        <input type="hidden" :id="id" :value="email" />
      </div>
      <button @click="copyEmailToClipboard" class="contact-card__copyclipboard copy-contact" :class="{ 'active': isCopyClicked }" >
        <img class="copy-contact" v-if="isCopyClicked" src="@/assets/images/icons/checkmark.svg" />
        <img class="copy-contact" v-else src="@/assets/images/icons/copyclipboard.svg" />
        <span class="contact-card__copy-text copy-contact">{{ buttonText }}</span>
        <span class="tooltip copy-contact">{{ tooltipText }}</span>
      </button>
    </div>
    <template v-if="phones && phones.length">
      <div v-for="(phone, index) in phones" :key="index" class="contact-card__line contact-card__line-phone">
        <img class="contact-card__phone-icon" src="@/assets/images/icons/phone.svg" />
        <a class="contact-card__email contact-value" :href="`tel:${phone.phone}`">
          <span class="contact-value">{{ phone.phone }}</span>
        </a>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'ContactCard',

  props: {
    id: {
      type: String,
    },
    name: {
      type: String,
    },
    userName: {
      type: String,
    },
    email: {
      type: String,
    },
    phones: {
      type: Array,
      default: null,
    },
  },

  data() {
    return {
      isCopyClicked: false,
    };
  },

  computed: {
    tooltipText() {
      return this.isCopyClicked
        ? this.$t('contact.clipboardActiveEmail')
        : this.$t('contact.clipboardInactiveEmail');
    },

    buttonText() {
      return this.isCopyClicked
        ? this.$t('contact.addres_copied')
        : this.$t('contact.copy');
    },
  },

  methods: {
    copyEmailToClipboard() {
      const clipboard = document.querySelector(`#${this.id}`);
      clipboard.setAttribute('type', 'text');
      clipboard.select();

      try {
        this.isCopyClicked = true;
        setTimeout(() => {
          this.isCopyClicked = false;
        }, 1500);
        document.execCommand('copy');
      } catch (e) {
        console.error(e);
      }

      clipboard.setAttribute('type', 'hidden');
      window.getSelection().removeAllRanges();
    },
  },
};
</script>

<style lang="scss" scoped>
.contact-card {
  @apply py-8;
  &__line {
    @apply flex flex-col items-start text-xl;
    line-height: 28px;
    @media screen and (min-width: 768px) {
      @apply flex-row items-center;
    }
  }
  &__line-email {
    @apply flex-col items-start;
    margin-top: 14px;
    overflow: hidden;
    @media screen and (min-width: 768px) {
      @apply flex-row items-center;
    }

    &-wrapper {
      @apply flex items-center;
      width: 100%;
      @media screen and (min-width: 768px) {
        width: auto;
      }
    }
  }
  &__line-phone {
    @apply flex-row items-center;
    margin-top: 14px;
  }
  &__email-icon {
    min-width: 18px;
    width: 18px;
    height: 14px;
  }
  &__phone-icon {
    min-width: 18px;
    width: 18px;
    height: 17px;
  }
  &__name {
    @apply font-bold;
    @media screen and (min-width: 768px) {
      @apply pl-2;
    }
  }
  &__email {
    @apply text-base leading-tight text-lg;
    line-height: 28px;
    word-break: break-word;
    padding-left: 10px;
    &.contact-value {
      overflow: hidden;
    }
    .contact-value {
      @apply block;
      line-height: 28px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
  &__copy-text{
    font-weight: bold;
    white-space: nowrap
  }
  &__copyclipboard {
    @apply relative flex text-lg items-center ml-0;
    margin-top: 14px;
    font-weight: 1;
    line-height: 28px;
    background: transparent;
    color: #EC268F;
    @media screen and (min-width: 768px) {
      @apply mr-0 mt-0;
      margin-left: 14px;
    }
    &.active {
      color: rgb(23.921569%,64.313728%,28.235295%);
    }
    img {
      margin-right: 8px;
      width: 15px;
    }
    .tooltip {
      @apply hidden absolute text-white bg-black;
      opacity: 0;
      top: -8px;
      left: 50%;
      transform: translate(-50%, -80%);
      width: auto;
      white-space: nowrap;
      padding: 10px 20px;
      border-radius: 4px;
      pointer-events: none;
      font-size: 12px;
      line-height: 14px;
      transition: 0.5s transform, 0.3s opacity;
      @media screen and (min-width: 768px) {
        @apply block;
      }
      &:after,
      &:before {
        content: "";
      }
      &:before {
        @apply absolute;
        top: 100%;
        left: 50%;
        height: 0;
        width: 0;
        border: solid transparent;
        pointer-events: none;
        border-color: rgba(0, 0, 0, 0);
        border-top-color: #1b181a;
        border-width: 4px;
        margin-left: -4px;
        opacity: 0.9;
      }
    }
    &:hover .tooltip,
    &:focus .tooltip {
      opacity: 0.9;
      transform: translate(-50%, -100%);
      pointer-events: auto;
    }
  }
}
</style>
